<template>
  <div class="view-container">
    <view-header>
      Devices
      <template #items>
        <el-button icon="el-icon-plus" @click="onAdd"> Add</el-button>
      </template>
    </view-header>
    <el-table :data="items" style="width: 100%">
      <el-table-column prop="id" label="ID" width="45"></el-table-column>
      <el-table-column prop="subscribed" label="Status" width="60">
        <template slot-scope="scope">
          <span
            class="device-status"
            :class="{ ok: scope.row.subscribed }"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="Type" width="150">
        <template slot-scope="scope">
          <img
            v-if="scope.row.type == 'DAHUA'"
            class="device-type-dahua"
            src="@/assets/images/dahua.svg"
          />
          <img
            v-if="scope.row.type == 'HIKVISION'"
            class="device-type-hikvision"
            src="@/assets/images/hikvision.svg"
          />
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="IP"></el-table-column>
      <el-table-column prop="port" label="Port"></el-table-column>
      <el-table-column prop="login" label="Login"></el-table-column>
      <el-table-column prop="password" label="Password"></el-table-column>
      <el-table-column prop="createdBy" label="Created By"></el-table-column>
      <el-table-column prop="createdDate" label="Created Date">
        <template slot-scope="scope">
          <span v-bind:title="formatFull(scope.row.createdDate)">{{
            format(scope.row.createdDate)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="modifiedBy" label="Modified By"></el-table-column>
      <el-table-column prop="modifiedDate" label="Modified Date">
        <template slot-scope="scope">
          <span v-bind:title="formatFull(scope.row.modifiedDate)">{{
            format(scope.row.modifiedDate)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Operations">
        <template slot-scope="scope">
          <!--          <el-button size="mini" @click="onEdit(scope.row.id)">Edit</el-button>-->
          <!--          <el-button size="mini" type="danger" @click="onDelete(scope.row.id)">-->
          <!--            Delete-->
          <!--          </el-button>-->
          <el-dropdown @command="onCommand">
            <el-button>
              <i class="el-icon-arrow-down"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="!scope.row.subscribed"
                icon="el-icon-message-solid"
                :command="{ action: 'subscribe', id: scope.row.id }"
              >
                Subscribe
              </el-dropdown-item>
              <el-dropdown-item
                v-if="scope.row.subscribed"
                icon="el-icon-error"
                :command="{ action: 'unsubscribe', id: scope.row.id }"
              >
                Unsubscribe
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-s-tools"
                :command="{ action: 'edit', id: scope.row.id }"
              >
                Edit
              </el-dropdown-item>
              <el-dropdown-item
                divided
                icon="el-icon-delete-solid"
                :command="{ action: 'delete', id: scope.row.id }"
              >
                Delete
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="form.id ? 'Update device' : 'New device'"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="onDialogClose"
    >
      <el-form ref="form" :model="form" :rules="formRules" label-position="top">
        <el-form-item label="IP" prop="ip">
          <el-radio-group
            v-model="form.type"
            size="small"
            @change="onTypeChange"
          >
            <el-radio label="DAHUA" border>Dahua</el-radio>
            <el-radio label="HIKVISION" border>HikVision</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="IP" prop="ip">
          <el-input v-model="form.ip"></el-input>
        </el-form-item>
        <el-form-item label="Port" prop="port">
          <el-input-number
            v-model="form.port"
            controls-position="right"
            :min="0"
            :max="65536"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="Login" prop="login">
          <el-input v-model="form.login"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="checkConnection"
          >Check Connection</el-button
        >
        <el-button @click="onDialogClose">Cancel</el-button>
        <el-button type="primary" @click="onSave">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ViewHeader from "@/components/ViewHeader";
import moment from "moment";

export default {
  name: "Device",
  components: { ViewHeader },
  data() {
    return {
      items: [],
      form: {
        id: null,
        ip: null,
        type: "DAHUA",
        port: 37777,
        login: null,
        password: null,
      },
      formRules: {
        ip: [{ required: true, message: "Please input IP", trigger: "blur" }],
        port: [
          { required: true, message: "Please input Port", trigger: "blur" },
        ],
        login: [
          { required: true, message: "Please input Login", trigger: "blur" },
        ],
        password: [
          { required: true, message: "Please input Password", trigger: "blur" },
        ],
      },
      dialogVisible: false,
    };
  },
  methods: {
    reload() {
      const loader = this.$loading({
        lock: true,
      });
      this.$network
        .get("device")
        .then(({ data }) => {
          this.items = data;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Loading failed",
          });
        })
        .finally(() => {
          loader.close();
        });
    },
    onCommand(command) {
      switch (command.action) {
        case "edit": {
          this.onEdit(command.id);
          break;
        }
        case "delete": {
          this.onDelete(command.id);
          break;
        }
        case "subscribe": {
          this.onSubscribe(command.id);
          break;
        }
        case "unsubscribe": {
          this.onUnsubscribe(command.id);
          break;
        }
      }
    },
    onTypeChange() {
      if (this.form.type === "DAHUA") {
        this.form.port = 37777;
      } else {
        this.form.port = 8000;
      }
    },
    onAdd() {
      this.dialogVisible = true;
    },
    onEdit(id) {
      const loader = this.$loading({
        lock: true,
      });
      this.$network
        .get(`device/${id}`)
        .then(({ data }) => {
          this.form.id = data.id;
          this.form.ip = data.ip;
          this.form.port = data.port;
          this.form.login = data.login;
          this.form.password = data.password;
          this.form.type = data.type;
          this.dialogVisible = true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Loading failed",
          });
        })
        .finally(() => {
          loader.close();
        });
    },
    onSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = {
            ip: this.form.ip,
            port: this.form.port,
            login: this.form.login,
            password: this.form.password,
            type: this.form.type,
          };
          const loader = this.$loading({
            lock: true,
          });
          const request = this.form.id
            ? this.$network.put(`device/${this.form.id}`, data)
            : this.$network.post(`device`, data);
          request
            .then(() => {
              this.$message({
                type: "success",
                message: "Successfully saved!!!",
              });
              this.onDialogClose();
              this.reload();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Saving failed",
              });
            })
            .finally(() => {
              loader.close();
            });
        }
      });
    },
    onDelete(id) {
      this.$confirm(
        "This will permanently delete the item. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          const loader = this.$loading({
            lock: true,
          });
          this.$network
            .delete(`device/${id}`)
            .then(() => {
              this.$message({
                type: "success",
                message: "Delete completed",
              });
              this.reload();
            })
            .catch((e) => {
              this.$message({
                type: "info",
                message: "Deleting failed",
              });
              console.log(e.response);
            })
            .finally(() => {
              loader.close();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    onSubscribe(id) {
      const loader = this.$loading({
        lock: true,
      });
      this.$network
        .put(`device/subscribe/${id}`)
        .then(() => {
          this.reload();
        })
        .catch((e) => {
          console.log(e.response);
        })
        .finally(() => {
          loader.close();
        });
    },
    onUnsubscribe(id) {
      const loader = this.$loading({
        lock: true,
      });
      this.$network
        .put(`device/unsubscribe/${id}`)
        .then(() => {
          this.reload();
        })
        .catch((e) => {
          console.log(e.response);
        })
        .finally(() => {
          loader.close();
        });
    },
    onDialogClose() {
      this.form = {
        id: null,
        ip: null,
        port: 37777,
        login: null,
        password: null,
        type: "DAHUA",
      };
      this.dialogVisible = false;
    },
    checkConnection() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = {
            ip: this.form.ip,
            port: this.form.port,
            login: this.form.login,
            password: this.form.password,
            type: this.form.type,
          };
          const loader = this.$loading({
            lock: true,
          });
          this.$network
            .post(`device/check-connection`, data)
            .then(() => {
              this.$message({
                type: "success",
                message: "Successfully connected!!!",
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Connecting failed",
              });
            })
            .finally(() => {
              loader.close();
            });
        }
      });
    },
    format(timestamp) {
      return moment(timestamp).fromNow();
    },
    formatFull(timestamp) {
      return moment(timestamp).format("HH:mm:ss DD.MM.yyyy");
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style lang="scss" scoped>
img.device-type-dahua {
  height: 25px;
  width: auto;
}

img.device-type-hikvision {
  height: 16px;
  width: auto;
}

.device-status {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #f56c6c;

  &.ok {
    background-color: #67c23a;
  }
}
</style>
